import { render, staticRenderFns } from "./RequestMeal.vue?vue&type=template&id=b85a0142"
import script from "./RequestMeal.vue?vue&type=script&lang=js"
export * from "./RequestMeal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports